import React, { useEffect, useState, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { getFirestore, getDoc, doc,deleteDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import './editbusdetails.css';
import { useParams } from 'react-router-dom';
import { setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

// Set your Mapbox access token
mapboxgl.accessToken = 'pk.eyJ1IjoidXRrMTIzIiwiYSI6ImNsbnl2cmRicDB5NXcyaXFtNG11dzcwemoifQ.TnZtihEi0MMNGJLyVHoUhQ';
const firebaseConfig = {
  apiKey: "AIzaSyBLzMDDfd1hTNvat7-q3TuLfz0iRs5nFlw",
  authDomain: "final-bus-traking.firebaseapp.com",
  databaseURL: "https://final-bus-traking-default-rtdb.firebaseio.com",
  projectId: "final-bus-traking",
  storageBucket: "final-bus-traking.appspot.com",
  messagingSenderId: "672447756097",
  appId: "1:672447756097:web:049420c8c40ea3940d53c0",
  measurementId: "G-9N0BE3D56N"
};
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

const EditVehicle = () => {
  const navigate = useNavigate();
    const { documentId } = useParams();
    const [map, setMap] = useState(null);
    const [editedDocumentId, setEditedDocumentId] = useState('');
    const markerRef = useRef(null);
    const [cityInput, setCityInput] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [placeDetails, setPlaceDetails] = useState({
      placeName: '',
      latitude: '',
      longitude: '',
    });
    const [removeIndex, setRemoveIndex] = useState(0);
    const [savedPlaces, setSavedPlaces] = useState([]);
    const firestore = getFirestore();
    const [isPreviewVisible, setPreviewVisible] = useState(false);
    const [busNumber, setBusNumber] = useState('');
    const [driverMobileNumber, setDriverMobileNumber] = useState('');
    const [isNightMode, setIsNightMode] = useState(false);
  const auth = getAuth()
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        // If the user is not authenticated, navigate to the login page
        navigate("/login");
      }
    });

    // Cleanup the subscription when the component unmounts
    return () => unsubscribe();
  }, [navigate]);
    useEffect(() => {
        const fetchData = async () => {
          try {
            const docRef = doc(firestore, 'publicbuses', documentId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
              const data = docSnap.data();
              setSavedPlaces(data.Stations || []);
              setBusNumber(data.busNumber || '');
              setDriverMobileNumber(data.driverMobileNumber || '');
              setPreviewVisible(true);
              setEditedDocumentId(documentId);
              // Additional initialization logic can be added here
            } else {
              console.log('Document does not exist');
            }
          } catch (error) {
            console.error('Error fetching data from Firestore:', error);
          }
        };
    
        fetchData();
      }, [documentId, firestore]);
  const handleMarkerDrag = () => {
    if (markerRef.current) {
      const { lng, lat } = markerRef.current.getLngLat();
  
      setPlaceDetails(prevDetails => ({
        ...prevDetails,
        latitude: lat.toFixed(4),
        longitude: lng.toFixed(4),
      }));
    }
  };

  useEffect(() => {
    const initializeMap = () => {
      const newMap = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [76.9214, 15.1394],
        zoom: 13,
      });
      newMap.on('load', () => {
        setMap(newMap);
        const initialMarker = new mapboxgl.Marker({ draggable: true })
          .setLngLat([76.9214, 15.1394])
          .addTo(newMap);
        initialMarker.on('dragend', handleMarkerDrag);
        markerRef.current = initialMarker;
      });
      newMap.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
      return () => newMap.remove();
    };

    initializeMap();
  }, []);

  const handleCityInputChange = async (e) => {
    const inputValue = e.target.value;
    console.log(inputValue + ' 2')
    setCityInput(inputValue);

    if (inputValue.trim() !== '') {
      const karnatakaBoundingBox = '74.0509,11.5820,78.1479,18.4682';
      try {
        const response = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(inputValue)}.json?access_token=${mapboxgl.accessToken}&bbox=${karnatakaBoundingBox}`
        );
        const data = await response.json();
        const newSuggestions = data.features.map((feature) => ({
          placeName: feature.place_name,
          coordinates: feature.center,
        }));
        setSuggestions(newSuggestions);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (coordinates, placeName) => {
    if (markerRef.current) {
      markerRef.current.setLngLat(coordinates).addTo(map);
      setPlaceDetails({
        placeName,
        latitude: coordinates[1].toFixed(4),
        longitude: coordinates[0].toFixed(4),
      });
    }
    map.flyTo({
      center: coordinates,
      essential: true,
    });
    setCityInput(placeName);
    setSuggestions([]);
  };

  const handleAddButtonClick = () => {
    if (!placeDetails.placeName) {
      alert("Please fill city name");
      return;
    }
    if(!placeDetails.latitude || !placeDetails.longitude) {
      alert('Please select proper coordinate. You can drag map pin and place where you need');
      return;
    }
    const isDuplicate = savedPlaces.some(
      (savedPlace) =>
        savedPlace.placeName === placeDetails.placeName &&
        savedPlace.latitude === placeDetails.latitude &&
        savedPlace.longitude === placeDetails.longitude
    );

    if (isDuplicate) {
      alert('This place has already been added');
      return;
    }
    setSavedPlaces([...savedPlaces, placeDetails]);
    setPreviewVisible(true);
  };

  const handleRemoveButtonClick = () => {
    // Remove the latest added data from the list
    setSavedPlaces((prevPlaces) => {
      const updatedPlaces = [...prevPlaces];
      updatedPlaces.pop(); // Remove the last element
      if (updatedPlaces.length === 0) {
        setPreviewVisible(false);
      }
      return updatedPlaces;
    });
  };
  const handleRemovePlaceByIndex = (indexToRemove) => {
    setSavedPlaces((prevPlaces) => {
      if (indexToRemove >= 0 && indexToRemove < prevPlaces.length) {
        const updatedPlaces = [...prevPlaces];
        updatedPlaces.splice(indexToRemove, 1); // Remove the place at the specified index
        if (updatedPlaces.length === 0) {
          setPreviewVisible(false);
        }
        return updatedPlaces;
      } else {
        alert('Invalid index');
        return prevPlaces;
      }
    });
  };
  const handleDocumentIdChange = (e) => {
    setEditedDocumentId(e.target.value); // Update the edited document ID
  };

  const handleSubmitButtonClick = async () => {
    if (!documentId || !savedPlaces.length || !busNumber || !driverMobileNumber) {
      alert('Please fill in all required fields.');
      return;
    }
    if (driverMobileNumber.length !== 10) {
      alert('Enter a valid 10-digit number');
      return;
    }
  
    const user = auth.currentUser;
    if (!user) {
      alert('User not authenticated');
      return;
    }
  
    const userEmail = user.email;
    if (!userEmail) {
      alert('User does not have an email associated with their account');
      return;
    }
    // await deleteDoc(doc(firestore, `publicbuses/${documentId}`));
    const docRef = doc(firestore, 'publicbuses', editedDocumentId);
    const docSnap = await getDoc(docRef);
  
    if (docSnap.exists()) {
      const userConfirmation = window.confirm('Data already exists. Do you want to replace it?');
      if (!userConfirmation) {
        return;
      }
    }
    if(documentId != editedDocumentId){
      const userConfirmation = window.confirm('DocumentId changed, do you want you delete previous record?');
      if(userConfirmation){
        await deleteDoc(doc(firestore, `publicbuses/${documentId}`));
      }
    }
    try {
      const journeyDetails = {
        busNumber,
        driverMobileNumber,
        Stations: savedPlaces,
        userEmail,
      };
      const phonenumbers = {
        driverMobileNumber,
      };
      await setDoc(doc(firestore, 'phonenumbers',driverMobileNumber), phonenumbers);
      await setDoc(doc(firestore, 'publicbuses', editedDocumentId), journeyDetails);
      alert('Data added to Firestore successfully');
    } catch (error) {
      alert('Error adding data to Firestore: ', error);
    }
  };
  
  return (
    <div className={`custom-container`}>
      <div className="left-half">
      {(!isPreviewVisible) && (
            <ul>
              <h3> Steps to add locations: </h3>
              <li> Search for the Place name in the top of the search bar and select the required name.</li>
              {/* <li> Place the pin pointing to the required position more accurately </li> */}
              {/* <li> Can rename the place where the pin is pointing from the second Text box. </li> */}
              <li>Make sure to end the place name with the city name for easy identification </li>
              <li> Click '+' button to add place details.</li>
              <li> Click '-' button to remove the recently added place. </li>
              <li> Enter a 10-digit Driver Number </li>
              <li> Enter the Bus number (i.e., Either Bus Number or Place Number) </li>
              <li> Enter a Unique Document id for identification and click on Submit </li>
            </ul>
          )}
        {isPreviewVisible && (
          <div className="preview-container1">
            <h3>Preview:</h3>
            <div className="scroll-table-container">
              <table className='custom-table'>
                <thead>
                  <tr>
                    <th>Sl No</th>
                    <th>Place Name</th>
                    <th>Latitude</th>
                    <th>Longitude</th>
                  </tr>
                </thead>
                <tbody>
                  {savedPlaces.map((savedPlace, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{savedPlace.placeName}</td>
                      <td>{savedPlace.latitude}</td>
                      <td>{savedPlace.longitude}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <div className="right-half">
        <div className="input-container">
          <div>
            <input
              type="text"
              placeholder="Enter city name only"
              value={cityInput}
              onChange={handleCityInputChange} />
          </div>
          <ul>
            {suggestions.map((suggestion, index) => (
              <li key={index} onClick={() => handleSuggestionClick(suggestion.coordinates, suggestion.placeName)}>
                {suggestion.placeName}
              </li>
            ))}
          </ul>
          <div className="input-row">
              {/* <input type="text" placeholder="Place Name" value={cityInput} onChange={(e) => setPlaceDetails({ ...placeDetails, placeName: e.target.value })}  disabled/> */}
            <input type="text" placeholder='latitude' value={placeDetails.latitude} readOnly />
            <input type="text" placeholder='longitude' value={placeDetails.longitude} readOnly />
                      
            <div className="btn-container">
              <button onClick={handleAddButtonClick} className='btn-round'>+</button>
              <button onClick={handleRemoveButtonClick} className='btn-round'>-</button>
            </div>
          </div>
          <div className="input-button-container">
            <input
              type="text"
              placeholder="Enter Document ID"
              value={editedDocumentId}
              onChange={handleDocumentIdChange}
              className="input-document-id"
            />
            <button onClick={handleSubmitButtonClick} className='btn-round'>Submit</button>
          </div>
          <div className="input-button-container">
            <input
              type="text"
              placeholder="Enter Bus Number"
              value={busNumber}
              onChange={(e) => setBusNumber(e.target.value)}
              className="input-document-id" />
            <input
              type="tel"
              placeholder="Enter Driver Mobile Number"
              value={driverMobileNumber}
              onChange={(e) => setDriverMobileNumber(e.target.value)}
              className="input-document-id"
              pattern="[0-9]{10}" />
              <input
                type="number"
                placeholder="SlNo to remove station"
                className="input-remove-index"
                onChange={(e) => setRemoveIndex(parseInt(e.target.value -1 , 10))}
              />
              <button
                onClick={() => handleRemovePlaceByIndex(removeIndex)}
                className='btn-round'>
                Remove
              </button>
          </div>
        </div>
        <div className="map-container" id="map" />
      </div>
    </div>
  );
};
export default EditVehicle;